import { FormEvent, useState } from 'react';
import { api } from '../../services/api';
import { Business } from '../../services/types';
import '../../styles/owner-sections.css';

export function PromotionsPanel({ business, token, onSaved }: { business: Business; token: string; onSaved: (business: Business) => void }) {
  const [editing, setEditing] = useState(false);
  const [reward, setReward] = useState(business.loyalty.reward);
  const [visitsRequired, setVisitsRequired] = useState(business.loyalty.visitsRequired);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  function startEditing() { setReward(business.loyalty.reward); setVisitsRequired(business.loyalty.visitsRequired); setError(''); setEditing(true); }

  async function save(event: FormEvent) {
    event.preventDefault(); setSaving(true); setError('');
    try {
      // Only reward/visitsRequired change here — everything else (colors,
      // logo, titles) has to be sent back as-is or updateCardCustomization
      // would reset it to the template defaults.
      const result = await api<{ business: Business }>('/business/card', token, { method: 'PUT', body: JSON.stringify({
        reward, visitsRequired,
        primaryColor: business.loyalty.primaryColor,
        accentColor: business.loyalty.accentColor,
        stampSecondaryColor: business.loyalty.stampSecondaryColor || '#FFFFFF',
        stampBadgeColor: business.loyalty.stampBadgeColor || '#FFFFFF',
        textColor: business.loyalty.textColor,
        cardTitle: business.loyalty.cardTitle || business.name,
        programName: business.loyalty.programName || 'Tarjeta de lealtad',
        rewardLabel: 'RECOMPENSA',
        logoDataUrl: business.loyalty.logoDataUrl || '',
      }) });
      onSaved(result.business);
      setEditing(false);
    } catch (failure) { setError(failure instanceof Error ? failure.message : 'No pudimos guardar los cambios.'); }
    finally { setSaving(false); }
  }

  return <div className="owner-page"><div className="owner-heading"><span>FIDELIDAD Y BENEFICIOS</span><h1>Promociones</h1><p>Lo que motiva a tus clientes a volver.</p></div><div className="promotion-grid"><article className="active-promotion"><div><span className="status-dot" /> Activa</div><small>RECOMPENSA PRINCIPAL</small>
    {editing ? <form className="promotion-edit" onSubmit={save}>
      <label>Recompensa<input value={reward} maxLength={24} onChange={(event) => setReward(event.target.value)} placeholder="Ej. Bebida gratis" autoFocus /></label>
      <label>Visitas para completar<input type="number" min={3} max={10} value={visitsRequired} onChange={(event) => setVisitsRequired(Math.min(10, Math.max(3, Number(event.target.value))))} /></label>
      {error && <p className="promotion-edit-error">{error}</p>}
      <div className="promotion-actions"><button type="button" onClick={() => setEditing(false)}>Cancelar</button><button disabled={saving}>{saving ? 'Guardando…' : 'Guardar'}</button></div>
    </form> : <>
      <h2>{business.loyalty.reward}</h2>
      <p>Cada cliente la desbloquea al completar <b>{business.loyalty.visitsRequired} visitas</b>.</p>
      <div className="promotion-stamps">{Array.from({ length: Math.min(business.loyalty.visitsRequired, 10) }, (_, index) => <i key={index}>{index + 1}</i>)}</div>
      <button onClick={startEditing}>Editar recompensa →</button>
    </>}
  </article><aside><span>PRÓXIMAMENTE</span><h3>Campañas temporales</h3><p>Promociones con vigencia, visitas dobles y beneficios por temporada.</p><div className="coming-item">☀️ Promoción de temporada</div><div className="coming-item">×2 Doble visita</div></aside></div></div>;
}
